import { all } from 'redux-saga/effects';
import { mainPageSaga } from './modules/MainPage/saga';
import { newsEventPageSaga } from './modules/NewsEventPage/saga';

const appSagas = [mainPageSaga, newsEventPageSaga];

export function* watchAppSaga(){
    yield all(appSagas.map(saga => saga()));
}
